import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

// /dashboard/daily-orderssss

//provideTags works for queries (get)
//invalidatesTags works for mutations (post, put, delete)

// These tags are just identifiers for different types of data
// When a mutation invalidates a tag, all queries that provide that tag will be re-fetched
const companyBaseEndpoint = ENDPOINTS.COMPANY;

// Daily Orders API
export const companyApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["company"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCompany: builder.query({
        query: () => `${companyBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "company" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      createCompany: builder.mutation({
        query: (requestData) => ({
          url: `${companyBaseEndpoint}`,
          method: "POST",
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "company" }],
      }),
      updateCompany: builder.mutation({
        query: ({id, requestData}) => ({
          url: `${companyBaseEndpoint}${id}`,
          method: "PUT",
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "company" }],
      }),
    }),
  });

// Export hooks for usage in components

export const { useGetCompanyQuery, useCreateCompanyMutation, useUpdateCompanyMutation } = companyApi;
